import { render, staticRenderFns } from "./CenterOfAttention.vue?vue&type=template&id=12c4ccd4&scoped=true&"
import script from "./CenterOfAttention.vue?vue&type=script&lang=js&"
export * from "./CenterOfAttention.vue?vue&type=script&lang=js&"
import style0 from "./CenterOfAttention.vue?vue&type=style&index=0&id=12c4ccd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4ccd4",
  null
  
)

export default component.exports